(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();
